const updateURL = ({ variantID }) => {
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantID);
  window.history.replaceState({}, '', url);
};

export default updateURL;
